<template>
  <div>
    <div class="login">
      <div class="accountLogin">注册您的账号</div>
      <div class="input">
        <el-input type="tel" v-model="companyName" placeholder="公司名称"></el-input>
      </div>
      <div class="input">
        <el-input
          type="password"
          v-model="password"
          placeholder="密码(必须同时包含字母和数字,长度>8)"
        ></el-input>
      </div>
      <div class="input">
        <el-input type="password" v-model="newPassword" placeholder="确认密码"></el-input>
      </div>
      <div class="input">
        <el-input type="text" v-model="name" placeholder="联系人"></el-input>
      </div>
      <div class="input">
        <el-input type="tel" v-model="phone" placeholder="手机号"></el-input>
      </div>
      <div class="input get_code">
        <el-input type="tel" v-model="code" placeholder="验证码"></el-input>
        <div class="code" ref="code" @click="getCode">获取验证码</div>
      </div>
      <!-- <div class="forget">
        <el-checkbox v-model="isHoldWeek">
          <span style="color: red">*</span>阅读并同意
        </el-checkbox>
      </div> -->
      <div class="loginBtn" @click="register">注册</div>
    </div>
    <div class="rigster" @click="toLogin">
      <div class="huiyuan"></div>
      已有账号？立即登录
    </div>
  </div>
</template>

<script>
import { registerAPI, getCodeAPI } from "@/api/index";
export default {
  data() {
    return {
      companyName: "",
      password: "",
      newPassword: "",
      phone: "",
      code: "",
      isHoldWeek: true,
      time: 60,
      name: "",
    };
  },
  methods: {
    async register() {
      if (!this.companyName) {
        this.$message.error("公司名称不能为空");
        return;
      }
      if (!this.password) {
        this.$message.error("密码不能为空");
        return;
      }
      let validationStr = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,})$/;
      console.log(this.password, validationStr.test(this.password));
      if (!validationStr.test(this.password)) {
        this.$message.error("密码格式错误");
        return;
      }
      if (this.password != this.newPassword) {
        this.$message.error("两次输入密码不一致");
        return;
      }
      if (!this.phone) {
        this.$message.error("手机号不能为空");
        return;
      }
      if (!this.code) {
        this.$message.error("验证码不能为空");
        return;
      }
      let data = {
        company_name: this.companyName,
        name: this.name,
        password: this.password,
        phone: this.phone,
        code: this.code,
      };
      registerAPI(data).then((res) => {
        localStorage.setItem("token", res.data.data.token);
        this.$message.success("恭喜你，注册成功!");
        this.toLogin();
      });
    },
    getCode() {
      let timer = null;
      if (!this.phone) {
        this.$message.error("手机号不能为空");
        return;
      }
      let data = {
        phone: this.phone,
        type: "register",
      };
      if (this.time == 60) {
        getCodeAPI(data).then((res) => {
          this.$message.success(res.data.msg);
          timer = setInterval(() => {
            this.time--;
            this.$refs.code.textContent = this.time + "s后重试";
            if (this.time == 0) {
              this.$refs.code.textContent = "获取验证码";
              this.time = 60;
              clearInterval(timer);
            }
          }, 1000);
        });
      }
    },
    toLogin() {
      this.$emit("changeType", 1);
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  width: 400px;
  // height: 296px;
  padding: 20px 30px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 5px;
  .accountLogin {
    width: 88px;
    height: 52px;
    line-height: 52px;
    text-align: left;
    margin-bottom: 20px;
    font-family: PingFangSC-Regular, sans-serif;
    border-bottom: 2px solid #409eff;
  }

  ::v-deep .el-input__inner {
    border: none !important;
  }

  ::v-deep .el-input__inner {
    background-color: transparent !important;
    color: #1a1a1a !important;
    border: none;
    padding: 0;
  }

  ::v-deep .el-input__inner::placeholder {
    color: #1a1a1a;
  }

  .input {
    margin-bottom: 20px;
    position: relative;
  }

  .el-input:hover::before {
    background: #ccc;
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    left: 0;
    bottom: 0;
  }

  .forget {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .loginBtn {
    width: 340px;
    height: 60px;
    margin: 20px auto 0;
    background: #409eff;
    color: #fff;
    cursor: pointer;
    line-height: 60px;
    border-radius: 5px;
    font-size: 16px;
    text-align: center;
    transition: all 0.3s linear 0s;
  }
  .loginBtn:hover {
    opacity: 0.7;
  }
  .get_code {
    display: flex;
    .el-input {
      flex: 1;
    }
    .code {
      width: 80px;
      text-align: center;
      cursor: pointer;
      line-height: 40px;
    }
    .code:hover {
      color: #409eff;
    }
  }
}

.rigster {
  line-height: 60px;
  height: 60px;
  width: 400px;
  border-radius: 5px;
  font-size: 16px;
  text-align: center;
  margin: 30px auto 0;
  transition: all 0.3s linear 0s;
  background: #409eff;
  color: #fff;
  cursor: pointer;

  .huiyuan {
    width: 16px;
    height: 18px;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("../../../../static/huiyuan.png");
    vertical-align: middle;
    margin-right: 5px;
  }
}

.rigster:hover {
  opacity: 0.7;
}
</style>
